import { SALUTATIONS } from 'cpool-constants';

import { getTitleCase } from './getTitleCase.js';

// Bare salutations (e.g. "HERR") are normalised to title case ("Herr"). Pre-formatted phrases pass through.
const BARE_SALUTATIONS = new Set<string>(Object.values(SALUTATIONS).map((salutation) => salutation.toLowerCase()));

/** Shared send/preview formatting for WhatsApp `applicant_salutation`. Returns null when missing. */
export function formatWhatsAppApplicantSalutation(anrede: string | null | undefined): string | null {
    const trimmed = anrede?.trim();
    if (!trimmed) return null;
    if (!BARE_SALUTATIONS.has(trimmed.toLowerCase())) return trimmed;
    return getTitleCase(trimmed) ?? trimmed;
}
